import { queryClient } from '@/api/queryClient';
import { useActiveAccount } from '@/store/active-account/active-account.store';
import { useAuth } from '@/store/auth/auth.store';
import { useChats } from '@/store/chats/chats.store';
import { useEvents } from '@/store/events/events.store';
import { useInvoice } from '@/store/expenses-store/invoices/invoices.store';
import { useQuotesStore } from '@/store/expenses-store/quotes/quotes.store';
import { useTransactionsStore } from '@/store/expenses-store/transactions/transactions.store';
import { useFoldersStore } from '@/store/folders/folders.store';
import { useMessages } from '@/store/messages/messages.store';
import { useTasks } from '@/store/tasks/tasks.store';
import { useVessels } from '@/store/vessels/vessels.store';
import { useWebSocket } from '@/store/websocket/websocket.store';

export const refreshAfterAccountSwitch = async () => {
  useActiveAccount.setState({ switching: true });
  try {
    await refresh();
  } finally {
    useActiveAccount.setState({ switching: false });
  }
};

const refresh = async () => {
  if ('caches' in window) {
    await Promise.allSettled([caches.delete('capacitor-api-cache'), caches.delete('api-cache')]);
  }

  await queryClient.invalidateQueries();

  useTasks.getState().clearTasks();
  useEvents.getState().clearEvents();
  useChats.setState({ chatRooms: null, chatRoom: null, bids: null, bid: null });
  useInvoice.setState({ invoices: [], invoice: null });
  useQuotesStore.setState({ quotes: null, quote: null });
  // Cursors are bound to the service they were issued under.
  useMessages.setState({
    messages: null,
    bidMessages: null,
    pinnedMessages: null,
    cursorByRoom: {},
  });
  useFoldersStore.setState({ folders: null });
  useVessels.setState({ myVessels: undefined, vessel: undefined, ownedVessels: undefined });

  useTransactionsStore.setState({
    transactions: [],
    transaction: null,
    transactionCategories: [],
  });
  await Promise.allSettled([
    useTransactionsStore.getState().getAllTransactions(),
    useTransactionsStore.getState().getTransactionsCategories(),
  ]);
  await useAuth.getState().me();

  useWebSocket.getState().disconnect();
  useWebSocket.getState().connect();

  // Many dashboard widgets fetch only on mount (stable function refs in useEffect deps),
  // so without a route remount they would render against the cleared store. Re-fetch the
  // data those widgets depend on so the screen repopulates after the switch.
  await Promise.allSettled([
    useEvents.getState().getAllEvents(),
    useTasks.getState().getAllTasks(),
    useChats.getState().getChatRooms(),
  ]);
};
